// Restore the imported-review source wording in this theme only.
(function () {
  const original = /Arvostelu kerätty toisen toimit{1,2}ajan kautta/gi;
  const replacement = 'Arvostelu tuotu aiemmasta verkkokaupasta';
  let scheduled = false;

  function correctSourceText() {
    scheduled = false;
    document.querySelectorAll('.jdgm-widget').forEach(function (widget) {
      const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement && node.parentElement.closest('script, style, textarea')) continue;
        const corrected = node.nodeValue.replace(original, replacement);
        if (corrected !== node.nodeValue) node.nodeValue = corrected;
      }
      widget.querySelectorAll('[title], [aria-label], [data-content], [data-original-title]').forEach(function (element) {
        ['title', 'aria-label', 'data-content', 'data-original-title'].forEach(function (attribute) {
          const value = element.getAttribute(attribute);
          if (!value) return;
          const corrected = value.replace(original, replacement);
          if (corrected !== value) element.setAttribute(attribute, corrected);
        });
      });
    });
  }

  function start() {
    correctSourceText();
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(correctSourceText);
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['title', 'aria-label', 'data-content', 'data-original-title']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
